// ColoCheckoutFields.jsx
import React, { useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import FormikBgpSwitch from "../../../inputs/form/FormikBgpSwitch";
import { usePageSettings } from "../../../../../contexts/PageSettingsContext";
import { PuffLoader } from "react-spinners";
import { useFetchServiceAddons } from "../../../../../utils/fetchAddons";
import TabTitle from "../TabTitle";

const PREFERRED_ORDER = ["os", "additionalIp", "bgp"];

// For the framer-motion animations
const fadeInUp = {
	initial: { opacity: 0, y: 20 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: 20 },
};

const ColoCheckoutFields = ({ handleAddonChange }) => {
	const { translations } = usePageSettings();

	const {
		data: serviceData,
		isLoading: isLoadingAddons,
		isError: failedLoadingAddons,
	} = useFetchServiceAddons("colocation");

	// Sort data by your preferred order
	const sortedServiceData = useMemo(() => {
		if (!serviceData) return [];
		return [...serviceData].sort((a, b) => {
			const iA = PREFERRED_ORDER.indexOf(a.type);
			const iB = PREFERRED_ORDER.indexOf(b.type);
			return iA - iB;
		});
	}, [serviceData]);

	if (isLoadingAddons) {
		return (
			<div className="flex flex-grow min-h-[500px] flex-col gap-2 text-center pt-20 items-center">
				<PuffLoader color="#DD097D" />
				<p className="flex gap-1">{translations["ConfigServerFormLoading"]}</p>
			</div>
		);
	}

	if (failedLoadingAddons) {
		return (
			<div className="flex flex-grow min-h-[500px] flex-col gap-2 text-center justify-center items-center">
				<p className="flex gap-1">{translations["ConfigServerFormLoadingFailed"]}</p>
			</div>
		);
	}

	return (
		<AnimatePresence>
			<TabTitle />
			<motion.div
				key="ColoCheckoutFields"
				className="grid grid-cols-1 md:grid-cols-2 gap-4 py-7 gap-x-12 gap-y-7"
				variants={fadeInUp}
				initial="initial"
				animate="animate"
				exit="exit"
			>
				{sortedServiceData.map((addon) => {
					// If it's a "bgp" type, render your BGP switch:
					if (addon.type === "bgp") {
						return (
							<div key={addon.type} className="flex text-sm gap-2">
								<FormikBgpSwitch
									label={translations["ToggleBGPSession"]}
									name={`configuration.${addon.type}`}
									bgpOptions={addon.options}
									handleAddonChange={handleAddonChange}
								/>
							</div>
						);
					}
				})}
			</motion.div>
		</AnimatePresence>
	);
};

export default ColoCheckoutFields;
